import { TableCell, Typography, TableCellProps } from '@mui/material';
import { makeStyles } from '@mui/styles';
import FindInPageIcon from '@mui/icons-material/FindInPage';
const useEmptyResultCellStyle = makeStyles(theme => ({
  icon: {
    padding: theme.spacing(3),
    fontSize: theme.typography.h3.fontSize,
    boxSizing: 'content-box',
  },
  title: {
    paddingBottom: theme.spacing(0.5),
    fontWeight: 500,
  },
  subtitle: {
    fontSize: theme.typography.subtitle2.fontSize,
    fontStyle: 'italic',
  },
}));

interface EmptyResultCellProps extends TableCellProps {
  hasFilters: boolean;
}

export const EmptyResultsCell = ({ colSpan, hasFilters }: EmptyResultCellProps) => {
  const classes = useEmptyResultCellStyle();

  return (
    <TableCell colSpan={colSpan} align="center">
      <div>
        <FindInPageIcon fontSize="large" color="disabled" className={classes.icon} />
        <Typography variant="h5" className={classes.title}>
          No results found
        </Typography>
        {hasFilters && (
          <Typography className={classes.subtitle}>
            Try adjusting your filters to find what you are looking for...
          </Typography>
        )}
      </div>
    </TableCell>
  );
};
